import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/flag-gray.svg'
import _imports_1 from '@/assets/images/flag-hover-pink.svg'


const _withScopeId = n => (_pushScopeId("data-v-98ce4cb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "flag",
  class: "position-absolute"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "flag active",
  class: "position-absolute"
}, null, -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

import { POST_STORE } from '@/store/constants'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { computed } from 'vue'
import { ROOT_STORE } from '@/store/constants'


export default /*#__PURE__*/_defineComponent({
  props: {
  favorite: Boolean,
  id: Number,
  create_by_admin: Boolean,
  isCSP: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const isMobile = computed<boolean>(() => store?.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])


const store = useStore()
const route = useRoute()

const handleClick = (): void => {
  store.dispatch(POST_STORE.ACTIONS.SET_FAVORITE, {
    post_id: props.id,
    favorite: !props.favorite,
    favoriteQuery: !!route.query.favorite,
    from_sf_10: props.isCSP,
  })
}

return (_ctx: any,_cache: any) => {
  return (!__props.create_by_admin)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([__props.favorite ? 'active' : '', !_unref(isMobile) ? 'hover-image' : '', 'flag cursor-pointer position-relative']),
        onClick: handleClick
      }, _hoisted_3, 2))
    : _createCommentVNode("", true)
}
}

})